import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertSection = async (section: Section) => {
  const response = await fetch(`${API_BASE_URL}/Section/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(section),
  });

  return response;
};

const updateSection = async (section: Section) => {
  const response = await fetch(`${API_BASE_URL}/Section/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(section),
  });

  return response;
};

const deleteSection = async (section: Section) => {
  const response = await fetch(`${API_BASE_URL}/Section/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(section),
  });

  return response;
};

const updatePositions = async (
  updates: { sectionId: number; newPosition: number }[]
) => {
  const response = await fetch(`${API_BASE_URL}/Section/UpdatePositions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Failed to update section positions");
  }

  return response;
};

const SectionService = {
  insertSection,
  updateSection,
  deleteSection,
  updatePositions,
};

export default SectionService;
